var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25029_8928",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25029_8928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.10397 12.1428L14.2436 6.00322C14.4183 5.82724 14.6233 5.73926 14.8586 5.73926C15.0937 5.73926 15.2993 5.82724 15.4754 6.00322C15.6514 6.17933 15.7394 6.3844 15.7394 6.61842C15.7394 6.85259 15.6541 7.05495 15.4836 7.22551L8.73043 13.9911C8.55557 14.1671 8.35057 14.2551 8.11543 14.2551C7.88015 14.2551 7.67445 14.1671 7.49834 13.9911L4.52918 11.022C4.35321 10.8459 4.26439 10.6413 4.26272 10.4084C4.26105 10.1755 4.3482 9.97099 4.52418 9.79488C4.70029 9.61891 4.90598 9.53092 5.14126 9.53092C5.3764 9.53092 5.57973 9.61891 5.75126 9.79488L8.10397 12.1428Z",
    fill: "#2D3245"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCheck);
export default __webpack_public_path__ + "static/media/ai-check.3228b0ce5f15a27e4bc7a1c88e3ff739.svg";
export { ForwardRef as ReactComponent };